var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33342H11.3333V4.00008C11.3333 2.16008 9.83999 0.666748 7.99999 0.666748C6.15999 0.666748 4.66666 2.16008 4.66666 4.00008V5.33342H3.99999C3.26666 5.33342 2.66666 5.93341 2.66666 6.66675V13.3334C2.66666 14.0667 3.26666 14.6667 3.99999 14.6667H12C12.7333 14.6667 13.3333 14.0667 13.3333 13.3334V6.66675C13.3333 5.93341 12.7333 5.33342 12 5.33342ZM5.99999 4.00008C5.99999 2.89341 6.89332 2.00008 7.99999 2.00008C9.10666 2.00008 9.99999 2.89341 9.99999 4.00008V5.33342H5.99999V4.00008ZM12 13.3334H3.99999V6.66675H12V13.3334ZM7.99999 11.3334C8.73332 11.3334 9.33332 10.7334 9.33332 10.0001C9.33332 9.26675 8.73332 8.66675 7.99999 8.66675C7.26666 8.66675 6.66666 9.26675 6.66666 10.0001C6.66666 10.7334 7.26666 11.3334 7.99999 11.3334Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a758064a48ef9635e372d03c63057241.svg";
export { ForwardRef as ReactComponent };